import React, { useState, useEffect } from "react";
import Arrow from "../Servce/Arrow";
import Particle from "../Particle";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Container, Row, Col } from "react-bootstrap";
import viddemo from '../../Assets/video-demo.png'
import lot from '../../Assets/lottie/right-arrow.json'
import { Player } from '@lottiefiles/react-lottie-player';
function ResumeNew() {
  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row style={{ justifyContent: "center", position: "relative" }}>
        <Col md={3} style={{ paddingBottom: 2 }}>
            <h1 className="heading-name">
            1.Go 2 Services</h1>
              <img
                src={viddemo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
            <Col md={1} style={{ paddingBottom: 2 }}>
            <Player
        src={lot}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '200px', width: '200px' }}
      />
      </Col>
            <Col md={4} style={{ paddingBottom: 2 }}>
            <h1 className="heading-name">
            2.Select Service</h1>
              <img
                src={viddemo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
            <Col md={1} style={{ paddingBottom: 2 }}>
            <Player
        src={lot}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={0.8}
        style={{ height: '200px', width: '200px' }}
      />
      </Col>
            <Col md={4} style={{ paddingBottom: 2 }}>
            <h1 className="heading-name">
            3.Fill a Form </h1>
              <img
                src={viddemo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
            <Col md={1} style={{ paddingBottom: 2 }}>
            <Player
        src={lot}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={0.6}
        style={{ height: '200px', width: '200px' }}
      />
      </Col>
            <Col md={4} style={{ paddingBottom: 2 }}>
            <h1 className="heading-name">
            4. We will Deliver u</h1>
              <img
                src={viddemo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
        </Row>

       
      </Container>
    </div>
  );
}

export default ResumeNew;
